import { createContext, useContext } from 'react';
export const ComponentContext = createContext<{
  renderActions: (element: JSX.Element) => void;
  blockBlur: (value: boolean) => void;
}>(null);
export function useComponentContext() {
  return useContext(ComponentContext);
}
